import moment from "moment";
import { PortfolioApi, PortfolioProfitApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";
import { useGlobalPeriod } from "../context";
import { ITimePeriod } from "../context/types";

export const useMonthlyPnlByAttribution = (
  portfolioId: string,
  overriddenPeriod?: ITimePeriod
) => {
  const { period: contextPeriod } = useGlobalPeriod();
  const period = overriddenPeriod || contextPeriod;
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;
  const api = new PortfolioProfitApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`portfolio-monthly-by-attribution`, { portfolioId, from, to }],
    () => api.getProfitByAttribution(portfolioId, from, to)
  );
};
